var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronUp = function SvgChevronUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.41L6.71001 1.17C6.61705 1.07628 6.50645 1.00188 6.38459 0.951114C6.26273 0.900345 6.13202 0.874207 6.00001 0.874207C5.868 0.874207 5.73729 0.900345 5.61543 0.951114C5.49357 1.00188 5.38297 1.07628 5.29001 1.17L1.05001 5.41C0.956281 5.50297 0.881887 5.61357 0.831118 5.73543C0.780349 5.85729 0.754211 5.98799 0.754211 6.12C0.754211 6.25202 0.780349 6.38272 0.831118 6.50458C0.881887 6.62644 0.956281 6.73704 1.05001 6.83C1.23737 7.01626 1.49082 7.1208 1.75501 7.1208C2.0192 7.1208 2.27265 7.01626 2.46001 6.83L6.00001 3.29L9.54001 6.83C9.72627 7.01475 9.97767 7.1189 10.24 7.12C10.3716 7.12077 10.5021 7.09554 10.6239 7.04578C10.7458 6.99601 10.8566 6.92269 10.95 6.83C11.0471 6.74039 11.1254 6.63242 11.1805 6.51235C11.2357 6.39227 11.2664 6.26246 11.2711 6.13043C11.2757 5.99839 11.2542 5.86675 11.2076 5.74309C11.1611 5.61944 11.0905 5.50623 11 5.41Z",
    fill: "#232340"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-up.6b5bd5bd.svg";
export { ForwardRef as ReactComponent };